<div class="d-flex flex-row">
    <div class="sp sp-circle"></div>
</div>